// src/components/home/CallToAction.tsx
import React from 'react';

interface CallToActionProps {
    onStart: () => void;
}

export const CallToAction: React.FC<CallToActionProps> = ({ onStart }) => {
    return (
        <section className="lp-cta">
            <div className="lp-cta__glow" aria-hidden="true" />
            <div className="lp-shell lp-cta__inner">
                <p className="lp-eyebrow">
                    <span className="lp-eyebrow__dot" />
                    Vahetus algab
                </p>
                <h2 className="lp-cta__title">Kas oled valmis korrakaitsjaks?</h2>
                <p className="lp-cta__lede">
                    Konto loomine võtab minuti. Mäng on tasuta ja töötab otse brauseris —
                    midagi pole vaja alla laadida.
                </p>
                <button type="button" className="lp-btn lp-btn--signal" onClick={onStart}>
                    Alusta karjääri
                </button>
            </div>
        </section>
    );
};
